<nz-page-header
  class="site-page-header"
  (nzBack)="onBack()"
  nzBackIcon
  [nzTitle]="'Update' | translate"
  [nzSubtitle]="user.email"
  *ngIf="user != null"
></nz-page-header>
<div class="user-record-container">
  <nz-row *ngIf="user != null">
    <nz-form-item nz-col nzSm="24" nzMd="12" style="padding-inline: 10px">
      <nz-row>
        <nz-form-label nz-col nzSpan="24">{{'Email' | translate}}</nz-form-label>
        <nz-form-control nz-col nzSpan="24">
          <input nz-input type="text" disabled [ngModel]="user.email" />
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    <nz-form-item nz-col nzSm="24" nzMd="12" style="padding-inline: 10px">
      <nz-row>
        <nz-form-label nz-col nzSpan="24">{{'Position' | translate}}</nz-form-label>
        <nz-form-control nz-col nzSpan="24">
          <input nz-input type="text" [(ngModel)]="user.position" />
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    <nz-form-item nz-col nzSm="24" nzMd="12" style="padding-inline: 10px">
      <nz-row>
        <nz-form-label nz-col nzSpan="24">{{'First Name' | translate}}</nz-form-label>
        <nz-form-control nz-col nzSpan="24">
          <input nz-input type="text" [(ngModel)]="user.firstName" />
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    <nz-form-item nz-col nzSm="24" nzMd="12" style="padding-inline: 10px">
      <nz-row>
        <nz-form-label nz-col nzSpan="24">{{'Last Name' | translate}}</nz-form-label>
        <nz-form-control nz-col nzSpan="24">
          <input nz-input type="text" [(ngModel)]="user.lastName" />
        </nz-form-control>
      </nz-row>
    </nz-form-item>

    <nz-form-item nz-col nzSm="24" nzMd="12" style="padding-inline: 10px">
      <nz-row>
        <nz-form-label nz-col nzSpan="24">{{'Role' | translate}}</nz-form-label>
        <nz-form-control nz-col nzSpan="24">
          <!-- <input nz-input type="text" [(ngModel)]="user.role" /> -->
          <nz-select [(ngModel)]="user.role">
            <nz-option
              *ngFor="let role of roles"
              [nzValue]="role.name"
              [nzLabel]="role.name"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    <nz-form-item nz-col nzSm="24" nzMd="12" style="padding-inline: 10px">
      <nz-row>
        <nz-form-label nz-col nzSpan="24">{{'Phone number' | translate}}</nz-form-label>
        <nz-form-control nz-col nzSpan="24">
          <input nz-input type="text" [(ngModel)]="user.phoneNumber" />
        </nz-form-control>
      </nz-row>
    </nz-form-item>
  </nz-row>
  <div class="submit-container">
    <button
      nz-button
      nzType="primary"
      class="border-radius"
      (click)="submitUser()"
    >
      {{'Submit' | translate}}
    </button>
  </div>
</div>
